import { HttpErrorResponse } from '@angular/common/http';
import {
  GetSessionSummaryResponse,
  PaymentRulesResponseV1,
  PreAuthorizedDebitMode,
} from '@arc/unified-payments-frontend/shared-payment';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const HostedPaymentsSessionComponentActions = createActionGroup({
  source: 'Hosted Payments Session Component',
  events: {
    'Session Initialize': emptyProps(),
    'Load Session Summary Success': props<{
      payload: GetSessionSummaryResponse;
    }>(),
    'Load Session Summary Error': props<{ error: HttpErrorResponse }>(),
    'Load Payment Rules Success': props<{ payload: PaymentRulesResponseV1 }>(),
    'Load Payment Rules Error': props<{ error: HttpErrorResponse }>(),
    'Load Pre Authorized Debit Mode Success': props<{
      payload: PreAuthorizedDebitMode;
    }>(),
    'Load Pre Authorized Debit Mode Error': props<{
      error: HttpErrorResponse;
    }>(),
  },
});
